import { render, staticRenderFns } from "./soleBottom.vue?vue&type=template&id=5b6f468f&scoped=true&"
import script from "./soleBottom.vue?vue&type=script&lang=js&"
export * from "./soleBottom.vue?vue&type=script&lang=js&"
import style0 from "./soleBottom.vue?vue&type=style&index=0&id=5b6f468f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f468f",
  null
  
)

export default component.exports